import { useEffect, useState } from "react"
import Alert from '@mui/material/Alert';

import styles from './AlertDanger.module.scss';

const AlertDanger = (props) => {

    const [ text, setText ] = useState('')

    useEffect(() => {
        setText(props.text)
    },[props])

    return (
        <div className={styles.alert_danger}><Alert severity="error">{ text }</Alert></div>
    )
}

export default AlertDanger